import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { AngularEditorComponent, AngularEditorConfig, AngularEditorModule } from '@kolkov/angular-editor';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { ConfirmAlertComponent } from '../../shared/confirm-alert/confirm-alert.component';
import { Subscription } from 'rxjs';
import { AppConstants } from '../../../utils/AppConstants';
import { ReportTemplate, ReportTemplateVar } from '../../../models/ReportTemplate';
import { ReportTemplateService } from '../../../services/report-template.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AppEnums } from '../../../models/AppEnums';
import { AlertService } from '../../shared/alert/alert.service';

@Component({
  selector: 'app-report-template-detail',
  standalone: true,
  imports: [
    CommonModule, 
    AngularEditorModule, 
    HasPermissionDirective, 
    ConfirmAlertComponent, 
    FormsModule, 
    ReactiveFormsModule],
  templateUrl: './report-template-detail.component.html',
  styleUrl: './report-template-detail.component.scss',
})
export class ReportTemplateDetailComponent implements OnInit, OnDestroy {
  [x: string]: any;
  paramSubscription!: Subscription;
  showConfirmationModal: boolean = false;
  confirmationMessage: string = '';

  id?: number;
  reportTemplate: ReportTemplate = {};
  detail_title: string = 'Nuovo template';
  @ViewChild('angularEditor') angularEditor?: AngularEditorComponent;
  @ViewChild('angularEditorHeader') angularEditorHeader?: AngularEditorComponent;
  innerHTML: string = "";
  headerHTML: string = "";

  previewHTML!: SafeHtml;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: false,
    height: 'auto',
    minHeight: 'calc(100vh - 520px)',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Inserisci qui',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],

    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    outline: false,
    toolbarHiddenButtons: [
      ['link', 'unlink', 'insertVideo']
    ],
    customClasses: [
      {
        name: 'Firme',
        class: '<!--',
        tag: 'table style="width:100%"><tr><td style="vertical-align: top">COL1</td><td style="vertical-align: top">COL2</td></tr></table> <!-- '
      },
      {
        name: 'Firme3',
        class: '<!--',
        tag: 'table style="width:100%;"><tr><td style="width:33.33%;vertical-align: top">COL1</td><td style="width:33.33%;vertical-align: top">COL2</td><td style="width:33.33%;vertical-align: top">COL3</td></tr></table> <!-- '
      }
     
    ]
  };

  editorHeaderConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '150px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Inserisci qui',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],

    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['link', 'unlink', 'insertVideo']
    ],
    rawPaste: true,
    customClasses: [
      
      {
        name: 'Intestazione',
        class: '<!--',
        tag: 'table><tr><td>COL1</td><td>COL2</td></tr></table> <!-- '
     } 
    ]
  };

  showHideVariableClassHeader = "hide"
  showHideVariableClass = "hide"
  reportTemplateVariables: ReportTemplateVar[] = []
  reportTemplateVariablesFiltered: ReportTemplateVar[] = []

  reportTemplateTypes = AppEnums.reportTemplateTypes

  constructor(
    private sanitizer: DomSanitizer, 
    private reportTemplateService: ReportTemplateService, 
    private alertService: AlertService, 
    private fullSpinnerService: FullSpinnerService, 
    private router: Router, 
    private activatedRoute: ActivatedRoute) {
    fullSpinnerService.spinner(undefined);

  }
  ngOnInit(): void {

    this.reportTemplateService.findAllVars().subscribe({
      next: (res) => {
        this.reportTemplateVariables = res
        this.reportTemplateVariablesFiltered = res
      }, complete: () => {
      }
      , error: () => {
      }
    });
    this.paramSubscription = this.activatedRoute.params.subscribe(parameter => {
      this.id = parameter['id'];
      if (this.id! > 0) {
        this.fullSpinnerService.spinner('');
        this.reportTemplateService.get(this.id!).subscribe({
          next: (res) => {
            this.reportTemplate = res;
            this.detail_title = res.name!;
            this.innerHTML = res.innerHtml!;
            this.headerHTML = res.headerHtml!
            this.previewHTML = this.sanitizer.bypassSecurityTrustHtml(res.headerHtml! + res.innerHtml!)

          }, complete: () => {
            this.fullSpinnerService.spinner(undefined);
          }
          , error: () => {
            this.fullSpinnerService.spinner(undefined);
          }
        });
      }
    });
  }
  onSubmit(loginForm: NgForm): void {
    if (loginForm.valid) {
      this.fullSpinnerService.spinner('');
      this.reportTemplate.innerHtml = this.angularEditor?.textArea.nativeElement.innerHTML
      this.reportTemplate.headerHtml = this.angularEditorHeader?.textArea.nativeElement.innerHTML
      this.reportTemplateService.save(this.reportTemplate).subscribe({
        next: (res) => {
          this.alertService.addErrors(AppConstants.titleSuccessMessage, [AppConstants.successMessage], true);
          this.router.navigate(['report-template']);
        }, complete: () => {
          this.fullSpinnerService.spinner(undefined);
        }
        , error: () => {
          this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }

  back() {
    this.router.navigate(['report-template']);
  }

  confirmDelete() {
    this.showConfirmationModal = true;
    this.confirmationMessage = "Sicuro di voler eliminare il template " + this.reportTemplate.name + ' ?';
  }

  cancelDelete() {
    this.showConfirmationModal = false;
  }

  delete() {
    this.fullSpinnerService.spinner('');
    this.reportTemplateService.delete(this.reportTemplate.id!).subscribe({
      next: (res) => {
        this.alertService.addErrors(AppConstants.titleDeleteSuccessMessage, [AppConstants.successMessage], true);
        this.router.navigate(['devices']);
      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }

  showHideVarialePanel(header: boolean) {
    if (header)
      this.showHideVariableClassHeader = this.showHideVariableClassHeader == "hide" ? "show" : "hide"
    else
      this.showHideVariableClass = this.showHideVariableClass == "hide" ? "show" : "hide"

  }

  filterVars(event: any) {
    let value = event.target.value;
    this.reportTemplateVariablesFiltered = this.reportTemplateVariables.filter(n => n.name!.toLowerCase().indexOf(value.toLowerCase()) > -1)

  }


  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
  }
}



